import { render, staticRenderFns } from "./DefectDetailPopup.vue?vue&type=template&id=7e064f50&scoped=true&"
import script from "./DefectDetailPopup.vue?vue&type=script&lang=js&"
export * from "./DefectDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./DefectDetailPopup.vue?vue&type=style&index=0&id=7e064f50&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e064f50",
  null
  
)

export default component.exports